import React from 'react';
import { RadioGroup } from '@headlessui/react';
import ValidationWrapper from '../validation/ValidationWrapper';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';

/* THIS COMPONENT LACKS LABEL, IT ONLY IMPLEMENTS THE **INPUT**  */

/**
 * Constant values for complex styling props
 */
const defaultClassNameITEM = {
	div: 'flex items-center rounded-3xl px-3 space-x-3 items-start cursor-pointer select-none w-full md:w-auto',
	buttonSelected: '',
	buttonActive: '',
	span: 'whitespace-pre-wrap block text-base',
};

function RadioButtonInput({
	name,
	value,
	onChange = () => {},
	items = [],
	colors,
	required,
	checkbbdd,
	translate,

	/* OPTIONAL PROPS */
	id,
	lastDefault,
	isVote,
	showValidation = true,
	confirmValue,
	confirmError,
	classNameOPTS = 'flex flex-col md:flex-row md:inline-flex w-full gap-y-5 md:gap-x-10 md:gap-y-5 md:flex-wrap md:justify-start items-center',
	styleOPTS,
	styleWRAPPER,
	classNameITEM,
	styleITEM,
}) {
	/* Default values for the styles */
	const defaultStyleOPTS = {
		color: colors?.text,
	};
	const defaultStyleWRAPPER = {
		borderBottom: null,
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleOPTS = { ...defaultStyleOPTS, ...styleOPTS };
	const overrideStyleWRAPPER = { ...defaultStyleWRAPPER, ...styleWRAPPER };

	const isDefaultChecked = () => {
		const itemsWithoutDefault = items.slice(0, -1);
		let checked = true;
		itemsWithoutDefault?.forEach(item => {
			if (item.value === value) {
				checked = false;
			}
		});
		return checked;
	};

	return <ValidationWrapper
		value={value}
		name={name}
		required={required}
		checkbbdd={checkbbdd}
		colors={colors}
		keepEmptySpace={false}
		errorOnTop={true}
		isVote={isVote}
		showValidationCustom={showValidation}
		confirmValue={confirmValue}
		confirmError={confirmError}
		styleDIV={overrideStyleWRAPPER}
	>
		<RadioGroup
			id={id}
			value={value}
			onChange={onChange}
			className='w-full md:w-auto'
		>
			<div className={classNameOPTS} style={overrideStyleOPTS}>
				{
					items.map(item => (
						<RadioGroup.Option
							key={item.value || Math.random() * 999} value={item.value}
							className='w-full md:w-auto'
						>
							{({ checked, active }) => (
								<Option
									item={item}
									checked={checked
										|| (lastDefault
											&& items.indexOf(item) === items.length - 1
											&& isDefaultChecked())
									}
									active={active}
									colors={colors}
									translate={translate}
									classNameITEM={classNameITEM}
									styleSPAN={styleITEM?.span}
								/>
							)}
						</RadioGroup.Option>
					))
				}
			</div>
		</RadioGroup>
	</ValidationWrapper>;
}

function Option({
	item,
	checked,
	colors,
	translate,

	/* OPTIONAL PROPS */
	classNameITEM,
	classNameIMG = 'self-center',
	styleDIV,
	styleSPAN,
}) {
	/* Icon hook */
	const { Circle, CircleChecked } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		transition: 'all 100ms ease-in',
	};
	const defaultStyleSPAN = {
		// We inheret it
	};


	/* This way you can modify or add fields without affecting the others */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideClassNameITEM = { ...defaultClassNameITEM, ...classNameITEM };
	const overrideStyleSPAN = { ...defaultStyleSPAN, ...styleSPAN };

	return (
		<div
			className={overrideClassNameITEM.div}
			style={overrideStyleDIV}
		>
			{/* This empty div prevents the inner "circle" elements form deforming */}
			<div>
				{checked ?
					CircleChecked && CircleChecked({ className: classNameIMG })
					: Circle && Circle({ className: classNameIMG })}
			</div>
			<span
				className={overrideClassNameITEM.span}
				style={overrideStyleSPAN}
			>
				{/* This covers both regular form input and vote input */}
				{getText(item, translate) || item.text}
			</span>
		</div>
	);
}

export default RadioButtonInput;
